"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaNumericOnly = AlphaNumericOnly;
exports.default = void 0;
function AlphaNumericOnly(e, dispatch, action) {
  var targetValue = e.target.value;
  var pattern = /^[a-z\d]+$/i;
  if (targetValue === '' || pattern.test(targetValue)) {
    dispatch({
      type: action,
      payload: [e.target.value]
    });
  }
}
var _default = AlphaNumericOnly;
exports.default = _default;